module.exports = __webpack_public_path__ + "static/media/book.cb74598b.yaml";


//////////////////
// WEBPACK FOOTER
// ./src/content/book.yaml
// module id = 650
// module chunks = 0